import { uiConstants } from '../constants/uiConstants';

const initialState = { commentPanel: false };

export default function ui(state = initialState, action) {
  switch (action.type) {
    case uiConstants.COMMENT_SIDEBAR:
      return {
        commentPanel: !state.commentPanel,
      };
    default:
      return state;
  }
}
